var anyBooleanIsTrue = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args.indexOf(true) !== -1;
};
export default anyBooleanIsTrue;
